<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 371.7 145.5" style="enable-background:new 0 0 371.7 145.5;" xml:space="preserve">
    <g>
      <defs>
        <rect id="t10_1_" y="43.8" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_2_">
        <use xlink:href="#t10_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            <path id="t10_3_" d="M0,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H9C4,101.7,0,97.7,0,92.7z"/>
          </defs>
          <clipPath id="t10_4_">
            <use xlink:href="#t10_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <path class="st2" d="M0,101.7V43.8h57.9v57.9H0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_5_" x="270.9" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_6_">
        <use xlink:href="#t10_5_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st3">
        <g>
          <defs>
            <path id="t10_7_" d="M270.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C275,57.9,270.9,53.9,270.9,48.9z"/>
          </defs>
          <clipPath id="t10_8_">
            <use xlink:href="#t10_7_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st4">
            <path class="st2" d="M270.9,57.9V0h57.9v57.9H270.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_9_" x="270.9" y="87.6" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_10_">
        <use xlink:href="#t10_9_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st5">
        <g>
          <defs>
            <path id="t10_11_" d="M270.9,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9
              C275,145.5,270.9,141.5,270.9,136.5z"/>
          </defs>
          <clipPath id="t10_12_">
            <use xlink:href="#t10_11_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st6">
            <path class="st2" d="M270.9,145.5V87.6h57.9v57.9H270.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_13_" x="302.1" y="43.8" width="69.7" height="57.9"/>
      </defs>
      <clipPath id="t10_14_">
        <use xlink:href="#t10_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st7">
        <g>
          <defs>
            <path id="t10_15_" d="M302.1,92.7V52.8c0-5,4-9,9-9h51.5c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-51.5
              C306.1,101.7,302.1,97.7,302.1,92.7z"/>
          </defs>
          <clipPath id="t10_16_">
            <use xlink:href="#t10_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st8">
            <path class="st2" d="M302.1,101.7V43.8h69.4v57.9H302.1z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_17_" x="194" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_18_">
        <use xlink:href="#t10_17_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st9">
        <g>
          <defs>
            <path id="t10_19_" d="M194,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,57.9,194,53.9,194,48.9z"/>
          </defs>
          <clipPath id="t10_20_">
            <use xlink:href="#t10_19_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st10">
            <path class="st2" d="M194,57.9V0h57.9v57.9H194z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_21_" x="116.9" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_22_">
        <use xlink:href="#t10_21_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st11">
        <g>
          <defs>
            <path id="t10_23_" d="M116.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C121,57.9,116.9,53.9,116.9,48.9z"/>
          </defs>
          <clipPath id="t10_24_">
            <use xlink:href="#t10_23_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st12">
            <path class="st2" d="M116.9,57.9V0h57.9v57.9H116.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_25_" x="46" y="43.8" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_26_">
        <use xlink:href="#t10_25_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st13">
        <g>
          <defs>
            <path id="t10_27_" d="M46,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H55C50,101.7,46,97.7,46,92.7z"/>
          </defs>
          <clipPath id="t10_28_">
            <use xlink:href="#t10_27_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st14">
            <path class="st2" d="M46,101.7V43.8h57.9v57.9H46z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_29_" x="43.8" y="0" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_30_">
        <use xlink:href="#t10_29_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st15">
        <g>
          <defs>
            <path id="t10_31_" d="M52.8,0h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V9C43.8,4,47.8,0,52.8,0z"/>
          </defs>
          <clipPath id="t10_32_">
            <use xlink:href="#t10_31_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st16">
            <path class="st2" d="M43.8,0h57.9v57.9H43.8V0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_33_" x="43.8" y="87.6" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_34_">
        <use xlink:href="#t10_33_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st17">
        <g>
          <defs>
            <path id="t10_35_" d="M52.8,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V96.6C43.8,91.6,47.8,87.6,52.8,87.6z"
              />
          </defs>
          <clipPath id="t10_36_">
            <use xlink:href="#t10_35_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st18">
            <path class="st2" d="M43.8,87.6h57.9v57.9H43.8V87.6z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_37_" x="116.9" y="87.6" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_38_">
        <use xlink:href="#t10_37_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st19">
        <g>
          <defs>
            <path id="t10_39_" d="M125.9,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9c-5,0-9-4-9-9V96.6C116.9,91.6,121,87.6,125.9,87.6
              z"/>
          </defs>
          <clipPath id="t10_40_">
            <use xlink:href="#t10_39_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st20">
            <path class="st2" d="M116.9,87.6h57.9v57.9h-57.9V87.6z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_41_" x="194" y="87.6" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t10_42_">
        <use xlink:href="#t10_41_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st21">
        <g>
          <defs>
            <path id="t10_43_" d="M194,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,145.5,194,141.5,194,136.5z"/>
          </defs>
          <clipPath id="t10_44_">
            <use xlink:href="#t10_43_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st22">
            <path class="st2" d="M194,145.5V87.6h57.9v57.9H194z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_45_" x="10.2" y="10.2" width="349.8" height="125.1"/>
      </defs>
      <clipPath id="t10_46_">
        <use xlink:href="#t10_45_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st23">
        <g>
          <defs>
            <path id="t10_47_" d="M24.2,10.2h322c7.7,0,14,6.3,14,14v97.1c0,7.7-6.3,14-14,14h-322c-7.7,0-14-6.3-14-14V24.2
              C10.2,16.5,16.5,10.2,24.2,10.2z"/>
          </defs>
          <clipPath id="t10_48_">
            <use xlink:href="#t10_47_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st24">
            <path class="st25" d="M10.2,10.2H360v125.1H10.2V10.2z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t10_49_" x="138.6" y="25.2" width="95.1" height="95.1"/>
      </defs>
      <clipPath id="t10_50_">
        <use xlink:href="#t10_49_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st26">
        <g>
          <defs>
            <circle id="t10_51_" cx="186.2" cy="72.8" r="47.6"/>
          </defs>
          <clipPath id="t10_52_">
            <use xlink:href="#t10_51_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st27">
            <path class="st2" d="M138.6,25.2h95.1v95.1h-95.1V25.2z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>

</template>
<script>
  export default {
    name: 't10'
  }
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
  .st0{clip-path:url(#t10_2_);}
  .st1{clip-path:url(#t10_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#t10_6_);}
  .st4{clip-path:url(#t10_8_);}
  .st5{clip-path:url(#t10_10_);}
  .st6{clip-path:url(#t10_12_);}
  .st7{clip-path:url(#t10_14_);}
  .st8{clip-path:url(#t10_16_);}
  .st9{clip-path:url(#t10_18_);}
  .st10{clip-path:url(#t10_20_);}
  .st11{clip-path:url(#t10_22_);}
  .st12{clip-path:url(#t10_24_);}
  .st13{clip-path:url(#t10_26_);}
  .st14{clip-path:url(#t10_28_);}
  .st15{clip-path:url(#t10_30_);}
  .st16{clip-path:url(#t10_32_);}
  .st17{clip-path:url(#t10_34_);}
  .st18{clip-path:url(#t10_36_);}
  .st19{clip-path:url(#t10_38_);}
  .st20{clip-path:url(#t10_40_);}
  .st21{clip-path:url(#t10_42_);}
  .st22{clip-path:url(#t10_44_);}
  .st23{clip-path:url(#t10_46_);}
  .st24{clip-path:url(#t10_48_);}
  .st25{fill:#85B0F9;}
  .st26{clip-path:url(#t10_50_);}
  .st27{clip-path:url(#t10_52_);}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/t10.vue